import request from '@/plugins/request';
import { IUser } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/index';

interface IGetResult {
  user: IUser;
}

export default {
  get(success: (res: IGetResult) => void) {
    utils.loading(true);

    request
      .get($url)
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      });
  },
};
